<template>
    <div class="border-t rounded-md bg-white shadow" :class="{'mb-8': active}">
        <div class="p-4 cursor-pointer" @click="toggle">
            <p class="pull-right">
                <i
                        class="fa"
                        v-bind:class="{
                        'fa-chevron-right': !active,
                        'fa-chevron-down': active,
                        }"
                ></i>
            </p>
            <p class="" :class="{'text-blue-900 font-bold': active, 'text-gray-700': !active}">
                <slot name="header"><i class="fa fa-fw fa-bell mr-4"></i> DUMMY TEXT</slot>
            </p>
        </div>

        <div v-if="active" class="p-4">
            <slot name="default"></slot>
        </div>

    </div>
</template>

<script>
    export default {
        name: "AccordionItem",
        inject: ["accordionState"],
        props: ["id", "open"],
        data: function () {
            return {};
        },
        computed: {
            active() {
                return this.accordionState.active === this.id;
            },
        },
        mounted() {
            if(parseInt(this.id) === parseInt(this.open)){
                this.toggle();
            }
        },
        methods: {
            toggle() {
                if (this.active) {
                    return this.close();
                }

                this.$emit('opened');

                this.accordionState.active = this.id;
            },
            close() {
                this.accordionState.active = null;
            }
        }
    }
</script>

<style scoped>

</style>
